import { OnInit } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { ThemeSettingService } from '../services/theme-setting.service';
var WebContentComponent = /** @class */ (function () {
    function WebContentComponent(workspaceService, themeSettingService) {
        this.workspaceService = workspaceService;
        this.themeSettingService = themeSettingService;
    }
    WebContentComponent.prototype.ngOnInit = function () {
        this.loaderConfig = this.themeSettingService.getTheme();
    };
    Object.defineProperty(WebContentComponent.prototype, "setComponentId", {
        set: function (id) {
            var _this = this;
            if (id) {
                this.componentId = id;
                this.isBusy = true;
                this.workspaceService.getWebContentCard(id).subscribe(function (result) {
                    _this.isBusy = false;
                    if (result) {
                        _this.embedLink = JSON.parse(result).EmbedLink;
                    }
                }, function (error) {
                    _this.isBusy = false;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    return WebContentComponent;
}());
export { WebContentComponent };
